import { ClubHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PostClubRenewData = (usasClubId, offeringInstanceId, registrationSignature, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const usasClubIdForUrl = usasClubId ? encodeURIComponent(usasClubId) : 'NaN';
    const url = `/UsasClub/ClubRenew?usasClubId=${usasClubIdForUrl}&offeringInstanceId=${offeringInstanceId}&registrationSignature=${registrationSignature}`;

    ClubHttpHelper(url, 'POST')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PostClubRenewData;